import axios from "axios";
window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    // 401 = Unauthenticated | 419 = CSRF token mismatch / sesión expirada
    if (status === 401 || status === 419) {
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);
